export default __webpack_public_path__ + "static/media/037-spring.54ff14be.svg";